import React, {useEffect, useState} from 'react';
// import React, {useState} from "react";
import NormalBtn from '../../StockItems/NormalBtn';
import NormalIcon from '../../StockItems/NormalIcon';
import * as PieceTogetherFn from './PieceTogetherFn';
import DeletedScreen from '../../DeletedScreen';
import { ethers } from 'ethers';
import DoGuide from '../../Tabs/DoGuide';
import RawTree from './RawTree';
import LevenshteinText from '../../LevenshteinText';
import * as ResponsiveFns from '../../utilities/ResponsiveFns';
import * as CoreFns from '../../utilities/CoreFns';
import * as ActionCasesFns from '../../utilities/ActionCasesFns';
import * as NamingFns from '../../utilities/NamingFns';
import * as StandardFns from '../../utilities/StandardFns';
import * as TypeChecks from '../../TypeChecks';
import * as TypeEvaluation from '../../TypeEvaluation';
import * as SharedAcross from '../../utilities/SharedAcross';
import * as SearchForAnEntityWithPath from '../../utilities/SearchForAnEntityWithPath';
import * as RAFormula from './RAFormula';
import * as Combos from './Combos';
import * as RBFormula from './RBFormula';
import SmartContractList from '../../Tabs/SmartContractList';
import DropdownMenu from '../../StockItems/DropdownMenu';
import 'react-datepicker/dist/react-datepicker.css';
import DatePicker from 'react-datepicker';

const Chart = (props) => {

  var currentList = props.currentList;
  var overallPath = props.path;
  var clickBack = props.clickBack;
  var userNos = props.userNos;
  var postFn = props.postFn;
  var addToExtraScreen = props.addToExtraScreen;
  var width = props.width;
  var height = props.height;
  var screenTitle = props.title;
  var logInState = props.logInState;
  var chains = props.chains;

  var leftHandPointer = 'o';
  var organicChanges = props.organicChanges;
  var startItemHighlighted = [-1];
  var startPathDown = [-1];

  var overallPathWithY = overallPath.concat(['y']);

  var fPiece;
  var rightSide;
  try{
    fPiece = CoreFns.goDownPath(currentList, overallPath, 0);
    if (fPiece.x.length === 0){
      startItemHighlighted = [];
      startPathDown = [];
    }
  }catch(err){

  }

  const [itemPathSet, setItemPathSet] = useState({itemHighlighted:startItemHighlighted, pathDown:startPathDown});

  var relevantSpace = CoreFns.goDownPath(currentList, overallPath, 0); //this is to see where the node is. that's different from relevantPath which is to find the actions etc that can be relevant.
    
  const [value, setValue] = useState('');
  const [value1, setValue1] = useState('');
  const [selectedType, setSelectedType] = useState('');

  var relevantPath = overallPath;
  if (overallPath[0] === 'as'){
    var searched = SearchForAnEntityWithPath.searchEntity(currentList, overallPath[1]);
    if (searched){
      relevantPath = searched.path;
    }
  }

  var actionCases = ActionCasesFns.getActionCasesFn(relevantPath);
  var smartContracts = ResponsiveFns.smartContractsFn(currentList);
  var network = CoreFns.currencyOfDatabase(currentList, chains);
  var chainId = CoreFns.relevantChainId(currentList);
  var rFormSets = RBFormula.findRForms(relevantPath, currentList);

  var isFeOrPuAndthisFe = {t:relevantPath[0], v:relevantPath[1]};
  
  function getVarsInAndType(pathToHere){
    return RBFormula.getVarsAndTypeIn(pathToHere, relevantSpace, currentList, overallPath, actionCases)
  }

  var gotErrorSomewhere = false;

  function pieceTogetherTree(keyPath, pathToHere, parentalKeyPath, parentalIndex, placeholder, toCheckForError){

    var node = CoreFns.goDownPath(relevantSpace, keyPath, 0);
    if (!node){
      return {title:'',c:[],pathToHere, xx:1,t:{t:'any'}, xS:[], keyPath, isRequired:1, parentalKeyPath, parentalIndex, placeholder, e:true};
    }

    var xS = node.x;
    var e = false;
    var typeRequired = {t:'any'};
    if (toCheckForError){
      var set = getVarsInAndType(pathToHere);
      if (xS.length === 0){
        toCheckForError = false;
      }else{
        var typeShown = RAFormula.getTypeRequiredK(relevantSpace, keyPath.concat(['x']), overallPath, currentList, set.varsIn, actionCases, false);

        if (!typeShown){
        }else if (set.typeRequired){
          typeRequired = set.typeRequired;
          if (set.typeRequired.t === 'Object' && typeShown.t === 'Separately Derived'){
            if (xS.length -1 === set.typeRequired.c.length){
              var cSet = set.typeRequired.c;
              for (var i1 = 0; i1 < cSet.length; i1++){
                var tin = cSet[i1].n;
                var haveFound = false;  
                for (var i2 = 1; i2 < xS.length; i2++){
                  if (xS[i2].ti === tin){
                    haveFound = true;
                    break;
                  }
                }
                if (!haveFound){
                  e = true;
                  break;
                }
              }
            }else{
              e = true;
            }
          }else{
            var inputCheck = TypeChecks.checkMatch(typeShown, set.typeRequired, true);
            if (!inputCheck){
              e = true;
            }
          }
          if (e){
            toCheckForError = false;
          }
        }else{
          e = true;
          // console.log(thisSide);
          // console.log(relevantSpace);
          // console.log(keyPath);
          // console.log(set);
        }
      }
    }

    var title = NamingFns.getTitleFromNode(node, currentList, overallPath, true, typeRequired);
    var c = [];
    var t = typeRequired;
    if (xS.length > 0){
      if (xS[0].t === 'f' ){
        var fnId = xS[0].v;
        var relevantFn = RAFormula.getRelevantFn(fnId);
        var more = relevantFn.more;
        var min = 0;
        var isRequiredNew = false;
        if (fnId === 61){
          min = 10000;
          // if (typeRequired.t === 'any'){
          //   more = 1;
          // }
        }else if (fnId === 60 || fnId === 66){
        }else if (relevantFn.in){
          min = relevantFn.in.length;
          if (xS.length - 1 <= min){
            isRequiredNew = true;
          }
        }

        c = xS.filter((aNode, index)=>{
          return +index > 0;
        }).map((aNode, index)=>{
          var nodeKey = aNode.v;
          var placeholder = '';
          if (relevantFn.tx){
            if (relevantFn.tx.length > index){
              placeholder = relevantFn.tx[index];
            }else{
              placeholder = relevantFn.tx[relevantFn.tx.length - 1];
            }
          }
          if (!placeholder){
            if (aNode.ti){
              placeholder = aNode.ti;
            }
          }
          var up = 1;
          if (fnId === 60 || fnId === 66){ //constructing of a list by elements, or assembling tables, cannot go up. 
            up = 0;
          }            
          
          return pieceTogetherTree(['y', nodeKey], pathToHere.concat([{k:nodeKey, i:+index+1, up, isRequired:isRequiredNew}]), keyPath, index + 1, placeholder, toCheckForError);
        })

        if (more){
          var moreTitle = '+ Variable';
          if (fnId === 66){
            moreTitle = '+ Event';
          }
          c.push({title:moreTitle,xx:1, c:[], pathToHere, t:'More', keyPath, relevantFn, e:false})
        }
      }else if (xS[0].t === 'eS' || xS[0].t === 'eV'){

        var thisAbi = ResponsiveFns.getToRelevantAbi(xS[0], currentList); 
        if (thisAbi){
          var thisAbiInputs = thisAbi.inputs;
          var thisAbiInputNames = thisAbiInputs.filter((aNode, index)=>{
            return xS[0].t === 'eS' || aNode.indexed;
          }).map((aNode, index)=>{
            return aNode.name;
          })

          c = xS.filter((aNode, index)=>{
            return (+index > 0)
          }).map((aNode, index)=>{
            var nodeKey = aNode.v;
            var placeholder;
            var up = 1;
            if (index < thisAbiInputNames.length){
              placeholder = thisAbiInputNames[index];
            }else{
              up = 0;
              placeholder = '';
            }
            if (xS[0].t === 'eV'){
              up = 0;
            }

            return pieceTogetherTree(['y', nodeKey], pathToHere.concat([{k:nodeKey, i:+index+1, up, isRequired:true}]), keyPath, index + 1, placeholder, toCheckForError);
          })

        }
      }else if (CoreFns.withP(xS[0].t) || xS[0].t === 'gi' || xS[0].t === 'u' || xS[0].t === 'inP'){

        var inputTypes = [];

        c = xS.filter((aNode, index)=>{
          return +index > 0;
        }).map((aNode, index)=>{
          var nodeKey = aNode.v;
          var placeholder;
          if (index < inputTypes.length){
            placeholder = inputTypes[index].ti;
          }else{
            placeholder = aNode.ti;
          }
          var child = pieceTogetherTree(['y', nodeKey], pathToHere.concat([{k:nodeKey, i:+index+1, up:1, isRequired:1}]), keyPath, index + 1, placeholder, toCheckForError);
          return child;
        })
      }else if (xS[0].t === 'scr'){
        var feSet = currentList.fe; 
        if (xS[0].v === overallPath[2]){
          return e;
        }
        if (!feSet[xS[0].v] && xS[0].v !== '_placeholderPage'){
          e = true;
        }
      }else if (xS[0].t === 'mus'){
        var muSet = currentList.mu; 
        if (xS[0].v === overallPath[2]){
          return e;
        }
        if (!muSet[xS[0].v]){
          e = true;
        }
      }else if (xS[0].t === 'footer'){
        if (currentList.fo && currentList.fo.on){

        }else{
          e = true;
        }
      }else if (xS[0].t === 'pa'){
        var relV = xS[0].v;
        if (relV[1] === isFeOrPuAndthisFe.v && relV[0] === isFeOrPuAndthisFe.t){
          var relevantScreenPath = [isFeOrPuAndthisFe.t, isFeOrPuAndthisFe.v, '_s'];
          var screens = CoreFns.goDownPath(currentList, relevantScreenPath);
          if (screens[relV[3]]){
          }else{
            e = true;
          }
        }else{
          e = true;
        }
      }else if (xS[0].t === 'al'){
        var relV1 = xS[0].v;
        if (relV1.length === 0){
          e = true;
        }else{
           try{
            var p = CoreFns.goDownPath(currentList, relV1);
            if (!p){
              e = true;
            }
           }catch(err){
            e = true;
           }
        }
      }else if (xS[0].t === 'pl'){
      }else if (xS[0].t === 's' || xS[0].t === 'i' || xS[0].t === 'ui'  || xS[0].t === 'dt' || xS[0].t === 'dc'|| xS[0].t === 'ad' || xS[0].t === 'ca' || xS[0].t === 'coin' || xS[0].t === 'curr' || xS[0].t === 'pu'){
      }else{
        console.warn(xS);
      }
    }
    if (e){
      gotErrorSomewhere = true;
    }
    return {title, xx:1, c, t, xS, pathToHere, keyPath, parentalKeyPath, parentalIndex, placeholder, e};
  }

  var tt = pieceTogetherTree([], [], false, -1, '', true);
  var treeData = [tt];
  
  useEffect(() => {
    var itemHighlighted = itemPathSet.itemHighlighted;
    var pathDown = itemPathSet.pathDown;
    if (itemHighlighted.join(" ") !== '-1'){
      var node = getNodeFromTreeData(treeData);
      var keyPath = node.keyPath;
      var pathToHere = node.pathToHere;
      var relevantItem = CoreFns.goDownPath(relevantSpace, keyPath, 0);

      var optionsAvailable = getOptionsAvailable( pathDown);
      if (optionsAvailable === 'error'){
        return;
      }

      var set = getVarsInAndType(pathToHere);
      var typeRequired = set.typeRequired;
      var title = NamingFns.getTitleFromNode(relevantItem, currentList, overallPath, false, typeRequired);

      if (relevantItem.x){
        if (relevantItem.x.length > 0){
          if (relevantItem.x[0].t === 'pl'){
            setValue1(relevantItem.x[0].p);
            title = relevantItem.x[0].v;
          }
        }
      }

      setValue(title);

      var xx = RAFormula.getTypeFromNode(relevantItem, typeRequired, currentList, overallPath, chainId, smartContracts, relevantSpace, pathDown, set.varsIn, actionCases, rFormSets, isFeOrPuAndthisFe);
      setSelectedType(xx);
    }  
  }, [itemPathSet]);


  if (!fPiece){
    return <DeletedScreen clickBack={clickBack} />
  }

  function goToAKeyPath(keyPath, pathDown){
    if (!keyPath){
      setItemPathSet({itemHighlighted:[-1], pathDown:[-1]});
    }else{
      setItemPathSet({itemHighlighted:keyPath, pathDown})
    }
  }


  function clickSubmit(e){

    var ttForm = PieceTogetherFn.consolidateAPathForm(overallPath, goToAKeyPath, currentList, actionCases);
    if (!ttForm){
      return;
    }

    var ansToCheck = {};
    var gotMissing = false;

    function pickUpAllYsUsed(startPoint, ySet){
      if (startPoint.length > 0){
        var firstPoint = startPoint[0];
        if (firstPoint.t === 'f' || firstPoint.t === 'eS' || CoreFns.withP(firstPoint.t)){
          for (var i = 1; i < startPoint.length; i++){
            var thisPoint = startPoint[i].v;
            ansToCheck[thisPoint] = 1;
            pickUpAllYsUsed(ySet[thisPoint].x, ySet);
          }
        }else if (CoreFns.justDirectFormulaNoSubsequent(firstPoint.t)){
        }else{
          console.warn(firstPoint);
          gotMissing = true;
        }
      }
    }

    

    var changes = [{t:'w',w:overallPath.concat(['t']),n:'formula'}, {t:'w',w:overallPath.concat([leftHandPointer]),n:ttForm}];

    pickUpAllYsUsed(relevantSpace.x, relevantSpace.y);

    if (!gotMissing){
      var yKeys = Object.keys(relevantSpace.y);
      yKeys.forEach((aYKey, index)=>{
        if (ansToCheck[aYKey]){
        }else{
          changes.push({t:'r', w:overallPath.concat(['y']), i:aYKey});
        }
      })
    }

    // var relevantSpace =  CoreFns.goDownPath(currentList, overallPath, 0);


    //do final type check here.
    fPiece.e = false;
    organicChanges(changes);
    if (postFn){
      postFn();
    }
    clickBack();
  }

  var appType;
  if (overallPath[0] === 'sc'){
    appType = 'smartContract';
  }else if (overallPath[0] === 'fe' || overallPath[0] === 'as' || overallPath[0] === 'pu'){
    appType = 'frontEnd';
  }

  var itemHighlighted = itemPathSet.itemHighlighted;

  function getOptionsAvailable(pathToHere){

    var set = getVarsInAndType(pathToHere);
    var typeRequired = set.typeRequired;

    if (!typeRequired || typeRequired === 'error'){
      return [];
    }

    var fns = StandardFns.functionalPieces;

    var fnKeys = Object.keys(fns);
    var fnPieces = fnKeys.map((aKey, index)=>{
      return fns[aKey];
    }).filter((aFn, index)=>{


      if (aFn.oFE){
        if (aFn.oFE === 1 && appType === 'smartContract'){
          return false;
        }else if (aFn.oFE === 2 && appType === 'frontEnd'){
          return false;
        }
      }

      if (aFn.net){
        if (aFn.net !== network){
          return false;
        }
      }

      if (typeRequired.t === 'ListType' && typeRequired.c.t === 'ScEvent'){
        if (aFn.i !== 66){
          return false;
        }
      }

      var p = TypeChecks.checkMatch(aFn.out, typeRequired, true);

      // if (aFn.i === 130){
      //   console.log(typeRequired);
      //   console.log(aFn);
      //   console.log(p);
      // }

      if (!p){
        return false;
      }

      if (typeRequired.t === 'UInteger' && aFn.out.t === 'UInteger'){
        if (typeRequired.sp === 'dateTime'){
          return aFn.out.sp === 'dateTime';
        }else{
          return aFn.out.sp !== 'dateTime';
        }
      }
      return true;
    });

    var specials = [];

    if (typeRequired.t === 'Object'){
      var txt = typeRequired.c.map((aC, index)=>{
        return aC.n;
      }).join(", ");
      specials.push({optionType:'objectSpecifiedIndividually', t:'Specify Object Components : ' + txt, c:typeRequired.c});
    }

    return specials.concat(fnPieces);

  }


  function reset(){
    goToAKeyPath(false, [-1]);
  }
  var itemHighlightedText = itemHighlighted.join(" ");

  function titleProp(node, path){

      var title = node.title;
      var type = node.t;
      var keyPath = node.keyPath;
      var pathToHere = node.pathToHere;
      var error = node.e;
      var relevantItem = CoreFns.goDownPath(relevantSpace, keyPath, 0);
      var placeholder = node.placeholder;

      if (type === 'More'){

        function onClickMore(){
          var idRow1 = CoreFns.uuidScoped(userNos, currentList, overallPathWithY, []);
          var y = {x:[]};
          var newX = JSON.parse(JSON.stringify(relevantItem.x));
          var toPush = {t:'g',v:idRow1};
          newX.push(toPush);
          var i = newX.length - 1;
          var L = LevenshteinText(relevantItem.x, newX, overallPath.concat(keyPath).concat(['x']));
          var changes = [{t:'w',w:overallPathWithY.concat([idRow1]),n:y}].concat(L);
          organicChanges(changes);
          goToAKeyPath(['y',idRow1], pathToHere.concat([{k:idRow1, i}]));
        }

        return <div className='selectionChoiceWhite' onClick={onClickMore} style={{width:'420px'}}>{title}</div>
      }
//      
      var clickSelect = function(e){
        goToAKeyPath(keyPath, pathToHere);
      }

      function clickReplace(e){
          var parentalItem = CoreFns.goDownPath(relevantSpace, node.parentalKeyPath, 0);
          var newX = JSON.parse(JSON.stringify(relevantItem.x));
          var L = LevenshteinText(parentalItem.x, newX, overallPath.concat(node.parentalKeyPath).concat(['x']));
          organicChanges(L);
          reset();
      }

      function clickShiftRight(e){
        var y = JSON.parse(JSON.stringify({x:relevantItem.x}));
        var idRow1 = CoreFns.uuidScoped(userNos, currentList, overallPathWithY, []);

        var newX = [{t:'u'},{t:'g',v:idRow1,ti:relevantItem.ti}];
        var L = LevenshteinText(relevantItem.x, newX, overallPath.concat(keyPath).concat(['x']));
        var changes = [{t:'w',w:overallPathWithY.concat([idRow1]),n:y}].concat(L);
        organicChanges(changes);
        reset();

      }

      function clickShiftUp(e){
        var parentalItem = CoreFns.goDownPath(relevantSpace, node.parentalKeyPath, 0).x;
        var parentalIndex = node.parentalIndex;
        var newX = []
        for (var i = 0; i < parentalItem.length; i++){
          if (i === parentalIndex){

          }else{
            if (i === parentalIndex - 1){
              newX.push(parentalItem[parentalIndex]);
            }
            newX.push(parentalItem[i]);
          }
        }
        var changes = LevenshteinText(parentalItem, newX, overallPath.concat(node.parentalKeyPath).concat(['x']));
        organicChanges(changes);
        reset();
      }

      function clickDelete(e){
        var parentalItem = CoreFns.goDownPath(relevantSpace, node.parentalKeyPath, 0);
        var newX = JSON.parse(JSON.stringify(parentalItem.x));
        newX.splice(node.parentalIndex, 1);
        var L = LevenshteinText(parentalItem.x, newX, overallPath.concat(node.parentalKeyPath).concat(['x']));
        organicChanges(L);

        // parentalItem.x.splice(node.parentalIndex, 1);
        reset();
      }
//
      var titlePiece = title;
      var coverPiece;
      if (type.ti){
        coverPiece = type.ti;
      }else if (placeholder){
        coverPiece = placeholder;
      }
      if (!titlePiece){
        titlePiece = <span>&nbsp;</span>
      }
//
      var coverPieceOut;
      if (coverPiece){
        coverPieceOut = <span style={{padding:'5px'}}>{coverPiece} : </span>
      }
      //

      var treeStyle;
      var color = 'black';
      if (error){
        color = 'red';
      }
      treeStyle = {width:'420px', color, padding:'5px', textDecoration:'underline', pointer:'cursor', backgroundColor:'#DDD'};
      var isRequiredPiece;
      var isRequiredSpace;
      var shiftUpPiece;
      var shiftUpSpace;
      var shiftLeftPiece;
      var shiftLeftSpace;
      var shiftRightPiece;
      var shiftRightSpace;

      function iconText(icon, fn, name){
        return <NormalIcon title={name} icon={icon} onClick={fn} />
      }

      if (keyPath.join(' ') === itemHighlightedText){
        treeStyle.fontWeight = 600;
        treeStyle.backgroundColor = 'yellow';

        if (pathToHere.length > 0){
          var isRequired = pathToHere[pathToHere.length - 1].isRequired;
          if (!isRequired){
            isRequiredSpace = ' '; 
            isRequiredPiece = iconText('ep:delete', clickDelete, 'Delete');
            if (pathToHere[pathToHere.length - 1].i > 1){ 
              shiftUpPiece = iconText('akar-icons:arrow-up', clickShiftUp, 'Shift Up');
              shiftUpSpace = ' ';
            }
          }
          if (pathToHere[pathToHere.length - 1].up){
            shiftLeftSpace = ' '; 
            shiftLeftPiece = iconText('akar-icons:arrow-left', clickReplace, 'Replace Parent Function with this'); 
          }
        }

        var set = getVarsInAndType(pathToHere);
        var typeRequired = set.typeRequired;
        if (typeRequired.t === 'Table' || (typeRequired.t === 'ListType' && typeRequired.c.t === 'ScEvent') || typeRequired.t === 'ScEvent' || typeRequired.t === 'MaybeSpecified'){ 
        }else{
          shiftRightSpace = ' ';
          shiftRightPiece = iconText('akar-icons:arrow-right', clickShiftRight, 'Move Down a Level');
        }

      }
      return <div className='selectionChoiceWhite'>{shiftLeftPiece}{shiftLeftSpace}{shiftUpPiece}{shiftUpSpace}{isRequiredPiece}{isRequiredSpace}{coverPieceOut}<span onClick={clickSelect} style={treeStyle}>{titlePiece}</span>{shiftRightSpace}{shiftRightPiece}</div>
    }
// 
  var aTree = <RawTree treeData={treeData} titleProp={titleProp} needGap={true} colorLines={true}/>

  function getNodeFromTreeData(treeData){
    var node = treeData[0];
    var pathDown = itemPathSet.pathDown;
    for (var i5 = 0; i5 < pathDown.length; i5++){
      node = node.c[pathDown[i5].i - 1];
    }
    return node;
  }  

  if (itemHighlighted[0] === -1){
    var extraForAdmin = null;
    if (CoreFns.isAdmin(logInState)){

      function clickCreateCombo(e){
        var x = relevantSpace.x;
        var y = relevantSpace.y;
        var x1 = JSON.parse(JSON.stringify({x,y}));        
        Combos.removeExtraYs(x1);
        console.log(JSON.stringify({x,y})); //do not delete
      }
      extraForAdmin = <NormalBtn title='[Admin] Create Combo' onClick={clickCreateCombo}/>
    }
    if (gotErrorSomewhere){
      rightSide = <center>Please fix errors in the formula, highlighted in red</center>
//
    }else{
      var ttForm = PieceTogetherFn.consolidateAPathForm(overallPath, goToAKeyPath, currentList, actionCases);
      if (ttForm){
        var needToShow = false;
        needToShow = true;
        if (relevantSpace.o){
          if (JSON.stringify(relevantSpace.o) === JSON.stringify(ttForm)){
            needToShow = false;
          }
        }
        if (needToShow){
          rightSide = <center><NormalBtn title='Update Formula' onClick={clickSubmit}/>{extraForAdmin}</center>
        }else{
          rightSide = <center>Implemented formula is up to date<br/>
          <NormalBtn title='Close' onClick={clickBack}/><br/>{extraForAdmin}</center>
        }
      }else{
          rightSide = <center>Please fix errors in the formula</center>
      }
    }


//    
  }else {
    var node = getNodeFromTreeData(treeData);
    var keyPath = node.keyPath;
    var pathToHere = node.pathToHere;
    var relevantItem = CoreFns.goDownPath(relevantSpace, keyPath, 0);
    var xS = node.xS;
    var added = [];

    function seeIfCanRecycle(newX, changes, inputType){
      var newXLengthPt = newX.length;
      //we should only do this if they are of the same type lol.
      if (xS.length > newXLengthPt){
        var current = xS[newXLengthPt].v;
        var typeShown = RAFormula.getTypeRequiredK(relevantSpace, keyPath.concat(['x']), overallPath, currentList, set.varsIn, actionCases, false);
        var inputCheck = TypeChecks.checkMatch(typeShown, inputType, true);
        if (inputCheck){
          return current;
        }
      }
      var idRow5 = CoreFns.uuidScoped(userNos, currentList, overallPathWithY, added);
      added.push(idRow5);

      var x = [];
      if (inputType.d){
        x = [inputType.d];
      }else if (inputType.t === 'Address'){
        x = [{t:'f', v:117}];
      }else if (inputType.t === 'UInteger' || inputType.t === 'nos' || inputType.t === 'any'){
        if (inputType.sp === 'dateTime'){
          x = [{t:'dt',v:Math.floor(new Date()/1000)}];
        }else{
          x = [{t:'ui',v:'0'}]
        }
      }else if (inputType.t === 'Integer'){
        x = [{t:'i',v:'0'}]
      }else if (inputType.t === 'Decimal'){
        x = [{t:'dc',v:'0'}]
      }else if (inputType.t === 'Text String'){
        x = [{t:'s', v:''}];
      }

      var y1 = {x};

      changes.push({i:idRow5, y:y1});
      relevantSpace['y'][idRow5] = y1;
      return idRow5;
    }

    function stepDownPaths(anOption, t, changes){
      var path = anOption.p;
      var newX = [{t,v:anOption.v, p:path}];

      return stepDownPathsAct(newX, anOption, changes);
    }

    function stepDownPathsAct(newX, anOption, changes){
      var path = anOption.p;
      path.filter((aP, index)=>{
        return aP.t === 'l';
      }).forEach((aP, index)=>{
        var idRow5 = seeIfCanRecycle(newX, changes, {t:'UInteger'});
        newX.push({t:'g',v:idRow5,ti:'List Item ' + (index + 1)});
      })
      return newX;
    }

    function actualSelect(valueHere){

        var newX;
        function specifyObjectFn(anOption, changes){
          var newX = [{t:'f',v:61}];
          anOption.c.forEach((anObj, index)=>{
            var idRow3;

            if (xS.length > 0){
              if (xS[0].t === 't' && xS[0].t === 61){
                for (var k1 = 0; k1 < xS.length; xS++){
                  if (xS[k1].ti === anObj.n){
                    idRow3 = xS[k1].v;
                    break;
                  }
                }
              }
            }

            if (!idRow3){
              idRow3 = seeIfCanRecycle(newX, changes, {t:'UInteger'});
            }
            // idRow3.ti = anObj.ti;

            newX.push({t:'g',v:idRow3,ti:anObj.n});
          })
          return newX;            
        }
        var changes = [];

        var optionsAvailable = getOptionsAvailable(pathToHere);
        for (var i = 0; i < optionsAvailable.length; i++){
          var anOption = optionsAvailable[i];
          var optionType = anOption.optionType;
          if (anOption.i === valueHere){
              if (optionType === 'gV' || optionType === 'm'){
  //inP.//ac
              var t = optionType;
              newX = stepDownPaths(anOption, t, changes);
            }else if (optionType === 'gi'){
              newX = [{t:optionType,v:anOption.v}];
            }else if (optionType === 'objectSpecifiedIndividually'){
              newX = specifyObjectFn(anOption, changes);
            }else{
              var min = 0;
              if (anOption.in){
                min = anOption.in.length;
              }
              var tt = 'f';
              var ins = {t:tt,v:anOption.i};
              if (anOption.i === 58 || anOption.i === 71 || anOption.i === 59 || anOption.i === 24){
               ins.m0 = CoreFns.uuidCheckEverywhere(userNos, currentList);
               try{
                if (xS[0].m0){
                  ins.m0 = xS[0].m0;
                }
               }catch(err){
               }
                if (anOption.i === 71 || anOption.i === 24){
                  ins.m1 = CoreFns.uuidCheckEverywhere(userNos, currentList);
                  try{
                    if (xS[0].m1){
                      ins.m1 = xS[0].m1;
                    }
                  }catch(err){
                  }
                }
              }else if (anOption.i === 60 || anOption.i === 66){
                min = 0; //this is to allow empty lists.
              }

              
              newX = [ins];
              var set = getVarsInAndType(pathToHere);
              var parentTypeRequired = set.typeRequired;

              var matching = {};
              if (anOption.out){
                if (anOption.out.v || anOption.out.v === 0){
                  matching[anOption.out.v] = parentTypeRequired;
                }
              }

              for (var j = 0; j < min; j++){

                var typeRequired = anOption.in[j];

                if (typeRequired.t === 'match'){
                  typeRequired = matching[typeRequired.v];
                  if (!typeRequired){
                    typeRequired = {t:'any'};
                  }
                }else if (typeRequired.v || typeRequired.v === 0){
                  matching[typeRequired.v] = typeRequired;
                }

                var idRow2 = seeIfCanRecycle(newX, changes, typeRequired);
                newX.push({t:'g', v:idRow2});
              }
              if (!optionType){
                if (anOption.more){ //this is so that we dont have to retype when we switch from + to *.
                  for (var j1 = min + 1; j1 < xS.length; j1++){
                    var origX= xS[j1].v; 
                    newX.push({t:'g', v:origX});
                  }
                }
              }
            }
            break;
          }
        }

        actualDo(newX, changes);
      

    }

    function actualDo(newX, changes){
      if (newX){
        var changesReal = changes.map((aChange, index)=>{
          return {t:'w',w:overallPathWithY.concat([aChange.i]),n:aChange.y};
        })
        var L = LevenshteinText(relevantItem.x, newX, overallPath.concat(keyPath).concat(['x']));
        organicChanges(changesReal.concat(L));
      }else{
        window.alert("Sorry, we don't understand this choice");
      }
        
      var firstChildSet = RBFormula.findGap([], [], pathToHere, relevantSpace);
      if (firstChildSet){
        goToAKeyPath(firstChildSet.keyPath, firstChildSet.pathToHere);
      }else{
        var secondChildSet = RBFormula.findGap([], [], [], relevantSpace);
        if (secondChildSet){
          goToAKeyPath(secondChildSet.keyPath, secondChildSet.pathToHere);
        }else{
          reset();              
        }
      }
    }

    var set = getVarsInAndType(pathToHere);

    var typeRequired = set.typeRequired;
    var optionTypes = RAFormula.getOptionTypesFromTypeRequired(typeRequired, currentList, overallPath, chainId, smartContracts, relevantSpace, pathToHere, set.varsIn, actionCases, rFormSets, isFeOrPuAndthisFe);

    var inside;
    for (var i8 = 0; i8 < optionTypes.length; i8++){
      if (optionTypes[i8].i === selectedType){
        inside = optionTypes[i8];
        break;
      }
    }

    function changeFn(e){
      setValue(e.target.value);
    }


    var currScreen = '';
    var details;
    var tempExtra;
    if (!inside){
    }else if (selectedType === 'eV' || selectedType === 'eS'){

        function clickSC(anOptionIS){

          var anOption = null;
          var set = anOptionIS.split(' ');
          var iS; var sS; 
          var nS;
          if (selectedType === 'eS' || selectedType === 'eV'){
            iS = set[0] + ' ' + set[1];
            sS = set[2];
            nS = set[3];
          }else{
            iS = set[0];
            sS = set[1];
          }

          for (var i = 0; i < inside.v.length; i++){
            var thisOption = inside.v[i];
            if (thisOption.v.i + '' === iS && thisOption.v.s === sS){
              if (selectedType === 'eV' || selectedType === 'eS'){
                if (thisOption.v.i === iS){
                  if (thisOption.v.n){
                    if (thisOption.v.n === nS){
                      anOption = thisOption;
                      break;                                      
                    }
                  }else{
                    anOption = thisOption;
                    break;                  
                  }
                }
              }else{
                anOption = thisOption;
                break;
              }

            }
          }

          if (anOption){

            var newX;
            var changes = [];
            var toAddListOfTriggers = false;
            if (selectedType === 'eS'){
                newX = [{t:'eS', i:anOption.v.i, s:anOption.v.s, n:anOption.v.n, a:anOption.v.a, p:anOption.p}];
                var thisAbi = ResponsiveFns.getToRelevantAbi({s:anOption.v.s, i:anOption.v.i}, currentList); 
                var nosInputs = 0;
                if (thisAbi){
                  nosInputs = thisAbi.inputs.length;
                }
                for (var j5 = 0; j5 < nosInputs; j5++){
                  var getInputType = TypeEvaluation.convertSCTypeToInternalType(thisAbi.inputs[j5]);
                  var idRow21 = seeIfCanRecycle(newX, changes, getInputType);
                  newX.push({t:'g',v:idRow21});
                }

                toAddListOfTriggers = true;
            }else if (selectedType === 'eV'){
                newX = [{t:'eV', i:anOption.v.i, s:anOption.v.s, p:anOption.p}];
                var thisAbi1 = ResponsiveFns.getToRelevantAbi(anOption, currentList); 
                if (thisAbi1){
                  thisAbi1.inputs.forEach((anInput, index)=>{
                    if (anInput.indexed){
                      var inputType = TypeEvaluation.convertSCTypeToInternalType(anInput);
                      var idRow22 = seeIfCanRecycle(newX, changes, inputType);
                      newX.push({t:'g',v:idRow22});
                    }
                  })
                }
            }
            stepDownPathsAct(newX, anOption, changes);
            if (toAddListOfTriggers){
              var idRow213 = seeIfCanRecycle(newX, changes, {t:'notNecc', d:{t:'f',v:66}});
              newX.push({t:'g',v:idRow213});
            }
            actualDo(newX, changes);

          }
        }

        currScreen = '';
        if (relevantItem.x && relevantItem.x[0] && relevantItem.x[0].t === selectedType){
          var n = '';
          if (relevantItem.x[0].n !== undefined){
            n = relevantItem.x[0].n
          }
          currScreen = relevantItem.x[0].i + ' ' + relevantItem.x[0].s + ' ' + n;
        }

        var scRows = inside.v.map((anInput, index)=>{
          var n = '';
          if (anInput.v.n !== undefined){
            n = anInput.v.n;
          }
          return {n:anInput.t, i:anInput.v.i + ' ' + anInput.v.s + ' ' + n};
        })

        
        details = <DropdownMenu isSortedAlphabetically={true} options={scRows} currentAnswer={currScreen} clickItemInSelect={clickSC}/>

        if ((selectedType === 'eS' || selectedType === 'eV') && relevantItem.x && relevantItem.x[0] && relevantItem.x[0].t === selectedType){
          var iXXX = relevantItem.x[0].i;
          if (+iXXX > 0 || iXXX === 0){
            function clickUpdate(e){
              var contractInfoAbi = CoreFns.getContractInfoAbi(currentList, relevantItem.x[0].s);
              var thisAbiNew = contractInfoAbi[iXXX];            
              var ppp = overallPath.concat(keyPath);
              relevantItem.x[0].i = thisAbiNew.name;
              var n = '';
              if (thisAbiNew.outputs.length > 0){
                n = thisAbiNew.outputs[relevantItem.x[0].n].name;
              }
              relevantItem.x[0].n = n;
              var changes = [{t:'w', w:ppp, n:relevantItem}];
              organicChanges(changes);
              reset();              
            }
            tempExtra = <button onClick={clickUpdate}>Update to new</button>
//
          }else{
            var parts = iXXX.split(' ');
            if (parts.length === 1){
              function clickUpdate1(e){
                var contractInfoAbi = CoreFns.getContractInfoAbi(currentList, relevantItem.x[0].s);

                var thisAbiNew = CoreFns.getAbiFnInfo(contractInfoAbi, relevantItem.x[0].i, true);
                var ppp = overallPath.concat(keyPath);
                relevantItem.x[0].i = thisAbiNew.name + ' ' + thisAbiNew.inputs.length;
                var changes = [{t:'w', w:ppp, n:relevantItem}];
                organicChanges(changes);
                reset();              
              }
              tempExtra = <button onClick={clickUpdate1}>Update to new 1</button>
  //

            }
          }

        }

      }else if (selectedType === 'aC'){

        currScreen = '';
        if (relevantItem.x && relevantItem.x[0] && relevantItem.x[0].t === selectedType){
          currScreen = relevantItem.x[0].v.k + ' ' + relevantItem.x[0].v.s;
          // currScreen = relevantItem.x[0];
        }

        var actionRows = inside.v.map((anInput, index)=>{
          return {n:anInput.t, i:anInput.v.k + ' ' + anInput.v.s};
        })

        function c3(val){
          var set = val.split(' ');
          for (var i = 0; i < inside.v.length; i++){
            var anInput = inside.v[i];
            if (anInput.v.k === +set[0] && anInput.v.s === set[1]){
              var changes = [];
              var path = anInput.p;
              var actLeft = {k:+set[0], s:set[1]};
              var newX = [{t:selectedType,v:actLeft, p:path}];
              stepDownPathsAct(newX, anInput, changes);
              actualDo(newX, changes);
              break;
            }

          }
        }

        details = <DropdownMenu isSortedAlphabetically={true} options={actionRows} currentAnswer={currScreen} clickItemInSelect={c3}/>

      }else if (selectedType === 'inP'){
        function clickInput(anInputPath){
          var path = [];
          var changes = [];
          var anOption = {optionType:'inP', v:anInputPath.split(' '), p:path}
          var newX = stepDownPaths(anOption, 'inP', changes);
          actualDo(newX, changes);
        }

        if (relevantItem.x && relevantItem.x[0] && relevantItem.x[0].t === 'inP'){
          currScreen = relevantItem.x[0].v.join(' ');
        }

        var inputRows = inside.v.map((anInput, index)=>{
          var pX = anInput.path.join(' ')
          var isCurrent = 'Input : ';
          if (overallPath.join(' ').indexOf(pX) === 0){
            isCurrent = '[Current] Input : ';
          }

          return {n:isCurrent + anInput.item._na, i:pX};
        })

        details = <DropdownMenu isSortedAlphabetically={true} options={inputRows} currentAnswer={currScreen} clickItemInSelect={clickInput}/>

      }else if (selectedType === 'oVar' || selectedType === 'm'){

        function clickInput(anInputV){
          for (var i = 0; i < inside.v.length; i++){
            var thisInput = inside.v[i];
            if (thisInput.v === anInputV){
              var changes = [];
              var anOption = {optionType:selectedType, v:anInputV, p:thisInput.p}
              var newX = stepDownPaths(anOption, selectedType, changes);
              actualDo(newX, changes);
              break;
            }
          }
        }

        if (relevantItem.x && relevantItem.x[0] && relevantItem.x[0].t === selectedType){
          currScreen = relevantItem.x[0].v;
        }

        var oVarRows = inside.v.map((anInput, index)=>{
          return {n:anInput.t, i:anInput.v};
        })

        details = <DropdownMenu options={oVarRows} currentAnswer={currScreen} clickItemInSelect={clickInput}/>

      }else if (selectedType === 'gV'){

        function clickGV(anInputV){
          for (var i = 0; i < inside.v.length; i++){
            var anInput = inside.v[i];
            if (anInput.v.join(' ') === anInputV){
              var changes = [];
              var newX = stepDownPaths(anInput, 'gV', changes);
              actualDo(newX, changes);
            }
          }
        }

        if (relevantItem.x && relevantItem.x[0] && relevantItem.x[0].t === 'gV'){
          currScreen = relevantItem.x[0].v.join(' ');
        }

        var governingRows = inside.v.map((anInput, index)=>{
          return {n:anInput.t, i:anInput.v.join(' ')};
        })
        details = <DropdownMenu options={governingRows} currentAnswer={currScreen} clickItemInSelect={clickGV}/>

      }else if (selectedType === 'coin' || selectedType === 'curr' || selectedType === 'pu'){
        var options = [];
        if (selectedType === 'coin'){
          options = CoreFns.coins();
        }else if (selectedType === 'curr'){
          options = CoreFns.currencies();
        }else if (selectedType === 'pu'){
          var pu = currentList.pu;
          if (pu){
            options  = Object.keys(pu).map((aP, index)=>{
              var thisPopUp = pu[aP];
              return {t:thisPopUp.n, i:aP};
            })
          }
        }

        var currVal = '';
        if (relevantItem.x && relevantItem.x[0] && relevantItem.x[0].t === selectedType){
          currVal = relevantItem.x[0].v;
        }

        var optionsX = options.map((anOption)=>{
          return {i:anOption.i, n:anOption.t};
        })
        function c4(i){
          actualDo([{t:selectedType, v:i}], []);
        }
        details = <DropdownMenu options={optionsX} currentAnswer={currVal} clickItemInSelect={c4}/> 
      }else if (selectedType === 'scr'){

        if (relevantItem.x && relevantItem.x[0] && relevantItem.x[0].t === 'scr'){
          currScreen = relevantItem.x[0].v;
        }
        //need to highlight culprit.
        var feSet = currentList.fe;
        var feKeys = Object.keys(feSet);


        var screenRows = feKeys.filter((aScreenKey, index)=>{
          return true;
          // return isFeOrPuAndthisFe.t === 'pu' || (isFeOrPuAndthisFe.v !== aScreenKey);
        }).map((aScreenKey, index)=>{
          var thisScreenX = feSet[aScreenKey];
          return {n:'Page : ' + thisScreenX.n, i:aScreenKey, a:'fluent:document-one-page-20-regular'};
        })

        screenRows.push({n:'Placeholder Page', i:'_placeholderPage', a:'radix-icons:component-placeholder'});

        function c5(i){
          actualDo([{t:selectedType, v:i}], []);
        }

        details = <DropdownMenu options={screenRows} currentAnswer={currScreen} clickItemInSelect={c5}/> 

      }else if (selectedType === 'mus'){

        if (relevantItem.x && relevantItem.x[0] && relevantItem.x[0].t === 'mus'){
          currScreen = relevantItem.x[0].v;
        }
        //need to highlight culprit.
        var muSet = currentList.mu;
        var muKeys = Object.keys(muSet);


        var musicRows = muKeys.map((aScreenKey, index)=>{
          var thisScreenX = muSet[aScreenKey];
          return {n:'Music : ' + thisScreenX.n, i:aScreenKey, a:'material-symbols:music-note'};
        })

        function c6(i){
          actualDo([{t:selectedType, v:i}], []);
        }

        details = <DropdownMenu options={musicRows} currentAnswer={currScreen} clickItemInSelect={c6}/> 


      }else if (selectedType === 'panels' || selectedType === 'al'){
        var key = 'pa';
        var title = 'Panels';
        if (selectedType === 'al'){
          key = 'al'
          title = 'Banners'
        }
        if (relevantItem.x && relevantItem.x[0] && relevantItem.x[0].t === key){
          currScreen = relevantItem.x[0].v.join(' ');
        }else if (selectedType === 'panels' && relevantItem.x && relevantItem.x[0] && relevantItem.x[0].t === 'footer'){
          currScreen = 'footer';
        }
        //need to highlight culprit.

        function clickScreenRow(a){
          if (a === 'footer'){
            actualDo([{t:'footer'}], [])
          }else{
            for (var i = 0; i < inside.v.length; i++){
              var aPanel = inside.v[i];
              if (aPanel.p.join(' ') === a){
                actualDo([{t:key,v:aPanel.p}], []);
                break;
              }
            }
          }
        }

        var panelRows = inside.v.map((aPanel, index)=>{
          return {n:aPanel.n, i:aPanel.p.join(' ')};
        })

        if (currentList.fo && currentList.fo.on && selectedType === 'panels'){
          panelRows.push({n:'Footer Panel',i:'footer'});          
        }

        if (panelRows.length > 0){
          details = <DropdownMenu options={panelRows} currentAnswer={currScreen} clickItemInSelect={clickScreenRow} />
        }else{
          details = <div>No {title} available</div>
        }
//        
      }else if (selectedType === 'contractAddress'){

        var smartContracts1 = currentList.sc;
        var smartContractKeys = Object.keys(smartContracts1);
        var contractRows = smartContractKeys.map((aSCKey, index)=>{
          var thisSCAddSets = smartContracts1[aSCKey].addSet;
          var addSetKeys = Object.keys(thisSCAddSets);
          var lo = thisSCAddSets[addSetKeys[0]];
          return {n:lo.contractName, i:aSCKey};
        })

        function clickContractAddress(a){
          actualDo([{t:'ca', v:a}], []);
        }
        var currContract;

        if (relevantItem.x && relevantItem.x[0] && relevantItem.x[0].t === 'ca'){
          currContract = relevantItem.x[0].v;
        }

        details = <DropdownMenu options={contractRows} currentAnswer={currContract} clickItemInSelect={clickContractAddress} />

      }else if (selectedType === 'freeDateTime'){

        function postChange(date){
          var g = Math.floor(date.getTime()/1000);
          var newX1 = [{t:'dt',v:g}];
          actualDo(newX1, []);          
        }
        var currValue = 0;
        if (relevantItem && relevantItem.x[0] && relevantItem.x[0].t === 'dt'){
          currValue = relevantItem.x[0].v;
        }

        var thisDate = new Date(currValue * 1000);

        details = <DatePicker selected={thisDate} showTimeSelect dateFormat='dd/MM/yyyy HH:mm:ss' className='inputBoxClassLong' onSelect={postChange} onChange={postChange} minDate={new Date(1970,0,0,0,0,0,0)}/>

//
      }else if (selectedType === 'freeText' || selectedType === 'freeInteger' || selectedType === 'freeUInteger' || selectedType === 'freeDecimal' || selectedType === 'freeAddress' || selectedType === 'freeTransaction'){


        function postKeyDown(valueHere){
          var newX;
          if (selectedType === 'freeText'){
            newX = [{t:'s',v:valueHere}];
          }else if (selectedType === 'freeInteger' || selectedType === 'freeUInteger' || selectedType === 'freeDecimal' || selectedType === 'freeAddress' || selectedType === 'freeTransaction'){
            valueHere = valueHere.trim();
            if (selectedType === 'freeInteger'){
              var isInt = SharedAcross.isIntegerText(valueHere);
              if (isInt){
                newX = [{t:'i',v:valueHere}];
              }else{
                window.alert('Need a integer value');
                return;
              }
            }else if (selectedType === 'freeUInteger'){
              var isInt1 = SharedAcross.isPositiveIntegerOrZeroText(valueHere);
              if (isInt1){
                if (+valueHere >= 0){
                  newX = [{t:'ui',v:valueHere}];
                }else{
                  window.alert('Need a positive integer or zero value');
                  return;

                }
              }
            }else if (selectedType === 'freeDecimal'){
              var isDec = SharedAcross.isDecimalText(valueHere);
              if (isDec){
                  newX = [{t:'dc',v:valueHere}];
              }else{
                window.alert('Need a Decimal value');
                return;
              }
            }else if (selectedType === 'freeAddress'){

              var isEth = SharedAcross.isEthAddress(valueHere);
              if (isEth){
                var p10;
                var gotProblem = false;
                try{  
                  p10 = ethers.getAddress( valueHere.toLowerCase() );
                }catch(err){
                  gotProblem = true;
                }
                if (gotProblem){
                  window.alert('Invalid address. Addresses are of the form 0x1234567890123456789012345678901234567890');
                  return;
                }
                newX = [{t:'ad',v:p10}];
              }else{
                window.alert('Invalid address. Addresses are of the form 0x1234567890123456789012345678901234567890');
                return;
              }

            }else if (selectedType === 'freeTransaction'){

              var isEth2 = SharedAcross.isEthTransaction(valueHere);
              if (isEth2){
                newX = [{t:'tx',v:p10}];
              }else{
                window.alert('Invalid Transaction. Transactions are of the form 0x12345678901234567890123456789012345678901234567890123456789012345678901234567890');
                return;
              }

            }
          }
          actualDo(newX, []);          
        }

        function onKeyDownSpec(e){
          if (e.keyCode === 13){
            postKeyDown(value);
          }
        }

        var typeSpecificLine = null;
        if (selectedType === 'freeAddress'){
          typeSpecificLine = <SmartContractList value={value} currentList={currentList} postSelect={postKeyDown}/>
        }

        details = <center>
            <b>Please type in {inside.t}</b><br/>
            <input type='text' className='form-control' onKeyDown={onKeyDownSpec} value={value} onChange={changeFn}/>
            <br/>
            <NormalBtn title='Submit' onClick={function(e){postKeyDown(value)}}/>
            {typeSpecificLine}
        </center>
        //
      }else if (selectedType === 'formula'){

        function clickAddFunction(){
          addToExtraScreen({t:'feedback', v:'I would like to request for ' + value + ' to be added as a new function. Thank you.'});
        }

          var pathDown = itemPathSet.pathDown;

          var optionsAvailable = getOptionsAvailable( pathDown);
          if (optionsAvailable !== 'error'){

            var opt = optionsAvailable.map((anOption, index)=>{
              return {i:anOption.i, n:anOption.t};
            })

            var relevantItem1 = CoreFns.goDownPath(relevantSpace, keyPath, 0);
            var initX = ''
            if (relevantItem1.x && relevantItem1.x[0] && relevantItem1.x[0].t === 'f'){
              initX = relevantItem1.x[0].v;
            }
            details = <div>
              <DropdownMenu isSortedAlphabetically={true} clickItemInSelect={actualSelect} options={opt} currentAnswer={initX}/>
            <br/>
            <NormalBtn title='Request New Fn' onClick={clickAddFunction}/>
            </div>
        }
//
      }else if (selectedType === 'combos'){

        function selectCombo(item){

          var newX = item.x;
          var changes = [];
          var possibleConflicts = [];

          function goDownXToAddToChanges(x){

            for (var i = 1; i < x.length; i++){
              var idRow1 = CoreFns.uuidScoped(userNos, currentList, overallPathWithY, possibleConflicts);
              var tgt = x[i].v;
              var candidate = item.y[tgt];
              x[i].v = idRow1;
              changes.push({i:idRow1, y:candidate});
              possibleConflicts.push(idRow1);
              goDownXToAddToChanges(candidate.x);
            }
          }
          goDownXToAddToChanges(newX);
          actualDo(newX, changes);
        }

        details = <DropdownMenu isSortedAlphabetically={true} clickItemInSelect={selectCombo} options={inside.v} currentAnswer={''}/>

//

      }else if (selectedType === 'pl'){

        function changeFn1(e){
          setValue1(e.target.value);
        }

        function submitPlaceholder(e){
          if (inside.type === 'Text String'){
          }else if (inside.type === 'Integer'){
            var isInt = SharedAcross.isIntegerText(value);
            if (!isInt){
              window.alert('Need a integer value');
              return;
            }
          }else if (inside.type === 'UInteger'){
            var isInt1 = SharedAcross.isPositiveIntegerOrZeroText(value);
            if (isInt1 && (+value >= 0)){
            }else{
              window.alert('Need a positive integer or zero value');
              return;
            }

          }else if (inside.type === 'Decimal'){
            var isDec = SharedAcross.isDecimalText(value);
            if (!isDec){
              window.alert('Need a Decimal value');
              return;
            }
          }else if (inside.type === 'Address'){
            var isEth = SharedAcross.isEthAddress(value);
            if (!isEth){
              window.alert('Invalid address. Addresses are of the form 0x1234567890123456789012345678901234567890');
              return
            }
          }else if (inside.type === 'Transaction'){
            var isEth1 = SharedAcross.isEthTransaction(value);
            if (!isEth1){
              window.alert('Invalid Transaction. Transactions are of the form 0x12345678901234567890123456789012345678901234567890123456789012345678901234567890');
              return
            }
          }
          var newX = [{t:'pl',v:value,p:value1,ti:inside.type}];
          actualDo(newX, []);          
        }

        details = <center>
            <b>Placeholder Value</b><br/>
            <input type='text' className='form-control' value={value} onChange={changeFn}/>
            <br/>
            <b>Placeholder Guidance Text</b><br/>
            <input type='text' className='form-control' value={value1} onChange={changeFn1}/>
            <br/>
            <NormalBtn title='Submit' onClick={submitPlaceholder}/>
        </center>

          
      }

//
    function clickSelectedType(newSelectedType){
      return function(e){
        setSelectedType(newSelectedType);
        setValue('')          
        setValue1('');
      }
    }

    var notes = [];
    if (typeRequired.t === 'UInteger' || typeRequired.t === 'Integer' || typeRequired.t === 'Text String' || typeRequired.t === 'Boolean'){
      var gotOwnVar = false;
      for (var i7 = 0; i7 < optionTypes.length; i7++){
        if (optionTypes[i7].i === 'oVar'){
          gotOwnVar = true;
          break;
        }
      }      
      if (!gotOwnVar){
        notes.push('Click on Definitions on the left-hand tab to add your own variables.');
      }
    }

    var pieces = optionTypes.map((aPiece, index)=>{

      var className = 'btn btn-outline-secondary btn-block h-100 d-inline-flex spreadTheButton';
      if (selectedType === aPiece.i){
        className = 'btn btn-secondary btn-block h-100 d-inline-flex spreadTheButton';
      }

      return  <div onClick={clickSelectedType(aPiece.i)} className='col-4 my-1'>
              <div className={className}>{aPiece.t}</div>
            </div>
    })

    var notesPiece = null;
    if (notes.length > 0){
      notesPiece = <div style={{paddingTop:'20px'}}>* {notes.join(' ')}</div>
//
    }
    rightSide = <div className='container'>
        <div className='row'>
          <div className='col-12'>
            <b>Options</b>
          </div></div>
        <div className='row'>
          {pieces}
        </div>
        <br/>
        {details}
        {tempExtra}
        {notesPiece}

         </div>
//
  }

  return <table style={{width, height}}><tbody>
    <tr>
      <td style={{width:width * 0.5, maxWidth:width * 0.5, verticalAlign:'top'}}>
        <div style={{overflowY:'scroll', height:'100%'}}>
          <center><h3>Formula for : {screenTitle}</h3>
          <DoGuide addToExtraScreen={addToExtraScreen} set={{t:'responsiveEditor'}} />

          </center>
          {rightSide}
        </div>
      </td>
      <td style={{width:width * 0.5, maxWidth:width * 0.5, verticalAlign:'top', }}>
        <div style={{overflowY:'scroll', height:'100%'}}>
          {aTree}
        </div>
    </td>
    </tr>

    </tbody></table>

}



export default Chart;